import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { borrarTokenSesion, getCookie } from '../cookies';
import { Fab } from '@mui/material'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LogoutIcon from '@mui/icons-material/Logout';



export const CerrarSesion = () => {

    const Navigate = useNavigate();
    const token = getCookie('PHPSESSID');

    const [logOut, setLogOut] = useState(false);


    const handleClose = () => {
        setLogOut(false);
    };

    const cerrarSesion = async () => {

        // Elimina la cookie llamada 'phpssid'
        borrarTokenSesion();
        localStorage.removeItem('username');
        localStorage.removeItem('code');
        localStorage.removeItem('mail');
        localStorage.removeItem('DesRepresentante');
        window.dispatchEvent(new Event('penya-auth-changed'));


        Navigate("/login");

        try {
            await axios.post('https://www.elpelobetxi.com/WS/Logout.php', {
                'token': token,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            // console.log('Respuesta del servidor:', response.data);
            // if (response.data.succes) {
            //     console.log(response)
            // }

        } catch (error) {
            console.error('Error en invalidar el token', error);
        }
    };
    return (
        <>
            {token && (
                <>

                    <Fab
                        variant="contained"
                        color="primary"
                        size='medium'

                        onClick={() => setLogOut(true)}
                    >
                        <LogoutIcon fontSize="small" />
                    </Fab>

                    <Dialog
                        open={logOut}
                        onClose={handleClose}
                        fullWidth
                        maxWidth='xs'
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">

                            <Typography variant="h4" style={{ textAlign: 'left' }}>
                                <LogoutIcon color='primary' sx={{ fontSize: 40, mb: -0.8 }} /> Tancar sessió?
                            </Typography>


                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">

                                <Typography variant="body1" style={{ textAlign: 'left' }}>
                                    Vols tancar la sessió?
                                </Typography>

                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                fullWidth
                                sx={{ m: 1 }}
                                size='large'
                                variant="outlined"
                                onClick={() => setLogOut(false)}
                                autoFocus
                            >
                                Cancel·lar
                            </Button>
                            <Button
                                fullWidth
                                sx={{ m: 1 }}
                                size='large'
                                variant="contained"
                                onClick={() => cerrarSesion()}
                                autoFocus
                            >
                                Acceptar
                            </Button>
                        </DialogActions>
                    </Dialog >
                </>

            )}
        </>
    );
}
